export default "__VITE_ASSET__DhavGbvn__"